var map = {
	"./consulting/contact-consulting.png": "Wep3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NwbM";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/contact\-consulting\.png$
// module id = NwbM
// module chunks = 0